import { useContext, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { post } from "../../adapters/xhr/api";
import MainContent from "../../layouts/maincontent/MainContent";
import InputElement from "../../shared/form/InputElement";
import stylesRequestData from "../../components/taxAppeal/appealRequestData/RequestData.module.css";
import TextAreaElement from "../../shared/form/TextAreaElement";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import arrowRightShort from "../../assets/img/arrow-right-short.svg";
import TaxAppealContext from "../../contexts/TaxAppealProvider";
import {
  getAppealRequestDetails,
  previewAndDownloadAppealFile,
  checkShowOptions,
} from "../../adapters/apis/taxAppeal/details";

const AppealPayment = () => {
  const taxAppealContext = useContext(TaxAppealContext);
  const { appealRequest, setAppealRequest, user, setUser, resetAppealRequest } =
    taxAppealContext;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [backendError, setBackendError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showOptionsCheckObject, setShowOptionsCheckObject] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsLoading(true);
        try {
          const response = await getAppealRequestDetails(id);
          setAppealRequest(response?.data?.data);
          setUser((prev) => ({
            ...prev,
            first_name: response?.data?.data?.user?.profile.first_name,
            father_name: response?.data?.data?.user?.profile.second_name,
            grandfather_name: response?.data?.data?.user?.profile.third_name,
            family_name: response?.data?.data?.user?.profile.fourth_name,
            email: response?.data?.data?.user?.email,
            phone_number: response?.data?.data?.user?.profile.mobile,
            nationality: {
              id: response?.data?.data?.user?.profile.nationality.id,
              key: response?.data?.data?.user?.profile.nationality.code,
              value: response?.data?.data?.user?.profile.nationality.name,
            },
            national_id: response?.data?.data?.user?.profile.national_id,
            passport_number: response?.data?.data?.user?.profile.passport_num,
            building_number:
              response?.data?.data?.user?.profile.real_estate_num,
            governorate_id: response?.data?.data?.user?.profile.governorate_id,
            district_id: response?.data?.data?.user?.profile.district_id,
            village_id: response?.data?.data?.user?.profile.village_id,
            street_id: response?.data?.data?.user?.profile.street_id ?? -1,
            street_other: response?.data?.data?.user?.profile.street_other,
            national_id_file:
              response?.data?.data?.user?.profile.national_id_file?.[0] || null,
            passport_number_file:
              response?.data?.data?.user?.profile.passport_num_file?.[0] ||
              null,
            profile: response?.data?.data?.user?.profile,
          }));
          if (!response?.data?.data?.visited) {
            const checkShowOptionsResponse = await checkShowOptions(id);
            setShowOptionsCheckObject(checkShowOptionsResponse?.data?.data);
            if (!checkShowOptionsResponse?.data?.data?.show_options) {
              navigate(`/tax-appeal/list-data`);
            }
          } else {
            navigate(`/tax-appeal/list-data`);
          }
          setIsLoading(false);
        } catch (error) {
          navigate(`/tax-appeal/list-data`);
        }
      }
    };

    fetchData();
  }, [id]);

  const handleAppealSameUnitTaxPeriodOrAnotherType = () => {
    // TODO disable the option of appealed_tax_period_type_id
    setAppealRequest((prev) => ({
      ...prev,
      disableAfterPayment: true,
      disableAfterPaymentDifferentPeriod: true,
      disableAfterPaymentSameBuilding: false, // TODO --- THIS SHOULD BE TRUE   -- NEED TO CHECK WITH AMMAR

      appeal_type_id: null,
      appealed_tax_period_type_id: null,

      acknowledge_not_submitted_same_data_before: null,
      acknowledge_all_documents_are_correct: null,
      acknowledge_unwillingness_submit_via_digital: null,

      has_additional_attachments: null,
      additional_attachments: [],
      status: null,
    }));
    navigate(`/tax-appeal/add`);
  };

  const handleAppealUnitSameBuilding = () => {
    setAppealRequest((prev) => ({
      ...prev,
      disableAfterPayment: true,
      disableAfterPaymentSameBuilding: true,
      disableAfterPaymentDifferentPeriod: false,
      linked_id: null,

      appeal_type_id: null,
      appealed_tax_period_type_id: null,
      appeal_reasons: null,
      unit_type_id: null,

      acknowledge_not_submitted_same_data_before: null,
      acknowledge_all_documents_are_correct: null,
      acknowledge_unwillingness_submit_via_digital: null,

      has_additional_attachments: null,
      additional_attachments: [],
      status: null,
    }));

    if (parseInt(appealRequest?.unit_address_type_id) === 1) {
      setAppealRequest((prev) => ({
        ...prev,
        unit_code: null,
      }));
    }

    if (parseInt(appealRequest?.unit_address_type_id) === 2) {
      setAppealRequest((prev) => ({
        ...prev,
        floor_text: null,
        unit_text: null,
        floor_id: null,
        unit_id: null,
        other_unit_text: null,
      }));
    }

    navigate(`/tax-appeal/add`);
  };

  const handleAppealAnotherBuilding = () => {
    resetAppealRequest();
    navigate(`/tax-appeal/add`);
  };

  const handleReSubmitPayment = async () => {
    setBackendError(null);
    try {
      const response = await post(
        `api/tax-appeal/pay/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
        appealRequest
      );
      initiatePayment(response);
    } catch (error) {
      setBackendError(
        error.response?.data?.data?.message || "خطأ في إرسال البيانات"
      );
      window.scrollTo(0, 0);
    }
  };

  const initiatePayment = (response) => {
    document.initiationForm.action = response?.data?.data?.payment_gateway_url;
    document.getElementById("SenderID").value = response?.data?.data?.sender_id;
    document.getElementById("RandomSecret").value =
      response?.data?.data?.random_secret;
    document.getElementById("RequestObject").value =
      response?.data?.data?.request_object;
    document.getElementById("HashedRequestObject").value =
      response?.data?.data?.hashed_request_object;
    document.getElementById("initiationForm").submit();
    window.scrollTo(0, 0);
  };

  return (
    <>
      <MainContent>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <form
              method="POST"
              id="initiationForm"
              name="initiationForm"
              action=""
            >
              <input type="hidden" name="SenderID" id="SenderID" value="" />
              <input
                type="hidden"
                name="RandomSecret"
                id="RandomSecret"
                value=""
              />
              <input
                type="hidden"
                name="RequestObject"
                id="RequestObject"
                value=""
              />
              <input
                type="hidden"
                name="HashedRequestObject"
                id="HashedRequestObject"
                value=""
              />
            </form>
            <section className={`section-content pt-md-0 pt-4 pb-5`}>
              <div className={`container`}>
                {backendError && (
                  <div
                    className="alert alert-danger text-center mt-3"
                    id="backend_error"
                    role="alert"
                  >
                    {backendError}
                  </div>
                )}

                {showOptionsCheckObject?.show_options && (
                  <div className="container mt-5">
                    {showOptionsCheckObject?.success ? (
                      <div className="box-content">
                        <div className="box">
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-success">
                              تم إيداع الطلب بنجاح،
                            </span>{" "}
                            هل ترغب في :
                          </h2>

                          <div className="d-flex flex-column align-items-center gap-3">
                            {showOptionsCheckObject?.can_add_appeal_request_for_same_unit && (
                              <button
                                className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                                onClick={
                                  handleAppealSameUnitTaxPeriodOrAnotherType
                                }
                              >
                                الطعن عن ذات الوحدة في فترة ضريبية أخرى أو بنوع
                                طلب آخر
                              </button>
                            )}
                            <button
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              onClick={handleAppealUnitSameBuilding}
                            >
                              الطعن عن وحدة أخرى بذات العقار
                            </button>
                            <button
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              onClick={handleAppealAnotherBuilding}
                            >
                              الطعن عن وحدة أخرى بعقار أخر
                            </button>

                            <div className="col-12 col-md-5 mt-4">
                              <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                                <button
                                  className="btn btn-primary p-3 col-12 col-md-5 fw-bolder"
                                  onClick={() =>
                                    navigate(`/tax-appeal/details/${id}`)
                                  }
                                >
                                  استعراض تفاصيل طلب الطعن
                                </button>
                                <button
                                  className="btn btn-outline-primary p-3 col-12 col-md-5 fw-bolder"
                                  onClick={() =>
                                    navigate(`/tax-appeal/list-data`)
                                  }
                                >
                                  العودة إلى قائمة طلبات الطعن
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="box-content">
                        <div className="box">
                          <h2 className="box-title mb-4 text-center">
                            <span className="text-danger">
                              تعذر سداد مبلغ التأمين،
                            </span>{" "}
                            هل ترغب في :
                          </h2>

                          <div className="d-flex flex-column align-items-center gap-3">
                            <button
                              className=" col-12 col-md-5 p-3 fw-bolder"
                              style={{
                                backgroundColor: "#FFD4D4",
                                border: "none",
                                borderRadius: "0.375rem",
                              }}
                              onClick={handleReSubmitPayment}
                            >
                              إعادة محاولة سداد مبلغ التأمين
                            </button>
                            <button
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              onClick={() =>
                                navigate(`/tax-appeal/details/${id}`)
                              }
                            >
                              استعراض تفاصيل طلب الطعن{" "}
                            </button>
                            <button
                              className="btn btn-primary col-12 col-md-5 p-3 fw-bolder"
                              onClick={() => navigate(`/tax-appeal/list-data`)}
                            >
                              العودة إلى قائمة طلبات الطعن{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </section>
          </>
        )}
      </MainContent>
      {/* )} */}
    </>
  );
};
export default AppealPayment;
